import { render } from "./OfferCard.vue?vue&type=template&id=1c2e404c&scoped=true"
import script from "./OfferCard.vue?vue&type=script&lang=js"
export * from "./OfferCard.vue?vue&type=script&lang=js"

import "./OfferCard.vue?vue&type=style&index=0&id=1c2e404c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2e404c"]])

export default __exports__